/**
 * @module Actions/UserActivity
 * @desc User activity (session / page) actions for dsilo-app-mngmt /useractivity APIs
 */
import { ActionTypes } from 'constants/index';

const safeDispatch = (dispatch, type, payload) => {
  try {
    if (typeof dispatch === 'function' && type) dispatch({ type, payload });
  } catch (e) {
    console.warn('[userActivity] safeDispatch failed', type, e);
  }
};

export const userActivitySessionStart = (payload) => (dispatch) => {
  safeDispatch(dispatch, ActionTypes.USER_ACTIVITY_SESSION_START, payload);
};

export const userActivitySessionEnd = (payload) => (dispatch) => {
  safeDispatch(dispatch, ActionTypes.USER_ACTIVITY_SESSION_END, payload);
};

export const userActivityPageSessionStart = (payload) => (dispatch) => {
  safeDispatch(dispatch, ActionTypes.USER_ACTIVITY_PAGE_SESSION_START, payload);
};

export const userActivityRecordEvent = (payload) => (dispatch) => {
  safeDispatch(dispatch, ActionTypes.USER_ACTIVITY_RECORD_EVENT, payload);
};
